import React from 'react';
import { motion } from 'framer-motion';

const Marquee = () => {
  const text = '專業室內設計 · PROFESSIONAL INTERIOR DESIGN · 商業空間規劃 · COMMERCIAL SPACE PLANNING · ';
  const repeatedText = text.repeat(3);

  return (
    <div className="relative overflow-hidden bg-gradient-to-r from-[#FF6B35] to-[#9CAF88] py-6">
      <motion.div
        animate={{
          x: [0, -1920],
        }}
        transition={{
          duration: 25,
          repeat: Infinity,
          ease: 'linear',
        }}
        className="flex whitespace-nowrap"
      >
        <span className="text-white text-2xl md:text-4xl font-bold tracking-wider">
          {repeatedText}
        </span>
      </motion.div>
    </div>
  );
};

export default Marquee;
